import { Mail, Phone, ArrowUp } from "lucide-react";
import { SITE } from "../data/site";
import Socials from "./Socials";

const scrollTop = () =>
  window.scrollTo({ top: 0, behavior: "smooth" });

export default function Footer() {
  return (
    <footer data-testid="site-footer" className="relative border-t border-white/5 bg-[#0A0A0C]">
      <div className="max-w-7xl mx-auto px-6 sm:px-8 md:px-12 py-16">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-10">
          <div className="md:col-span-5">
            <div className="font-serif-display text-3xl text-white tracking-tight">
              Isaiah <span className="italic text-[#A0A0A8]">Artavia</span>
            </div>
            <p className="mt-4 text-[#A0A0A8] text-sm leading-relaxed max-w-md">
              Actor & Performer — stage and screen. {SITE.contact.location}.
            </p>

            <div className="mt-6">
              <div className="overline mb-3">Follow</div>
              <Socials variant="row" />
            </div>
          </div>

          <div className="md:col-span-4">
            <div className="overline mb-5">Connect</div>
            <div className="flex flex-col gap-3 text-sm">
              <a data-testid="footer-email" href={SITE.contact.emailHref} className="cine-link flex items-center gap-3 text-[#A0A0A8]">
                <Mail size={14} className="text-[#991B1B]" />
                {SITE.contact.email}
              </a>
              <a data-testid="footer-phone" href={SITE.contact.phoneHref} className="cine-link flex items-center gap-3 text-[#A0A0A8]">
                <Phone size={14} className="text-[#991B1B]" />
                {SITE.contact.phone}
              </a>
            </div>
          </div>

          <div className="md:col-span-3 flex md:justify-end">
            <button
              data-testid="footer-scroll-top"
              onClick={scrollTop}
              className="self-start group inline-flex items-center gap-3 overline cine-link"
            >
              <span className="h-9 w-9 border border-white/10 group-hover:border-[#991B1B] flex items-center justify-center transition-colors">
                <ArrowUp size={14} />
              </span>
              Back to top
            </button>
          </div>
        </div>

        <div className="mt-14 pt-8 border-t border-white/5 flex items-center justify-between flex-wrap gap-3">
          <div className="text-xs text-[#6B6B72] tracking-wider">
            © {new Date().getFullYear()} Isaiah Artavia. All rights reserved.
          </div>
          <div className="text-xs text-[#6B6B72] italic font-serif-display">
            "A stage. A spotlight. A story worth telling."
          </div>
        </div>
      </div>
    </footer>
  );
}
